<template>
  <section id="about" class="about module" v-if="project">

    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <h2>The Best of Sacramento</h2>
        </div>

        <div class="col-xs-12">
          <div class="row">
            <div class="col-sm-4 about-column">
              <img class="about-header-image" src="/static/images/icon1.png" alt="The Then &amp; The Now">
              <p>
                Sacramento is hot—and it's really cool.  It's getting more and more national attention for its brewpubs, restaurants and quality of life.  But SN&amp;R has celebrated the Best of Sacramento for more than 25 years.  In this year's issue, we are featuring readers' picks.
              </p>
            </div>

            <div class="col-sm-4 about-column">
              <img class="about-header-image" src="/static/images/icon2.png" alt="Voting Categories">
              <p>
                Vote for your favorites in more than 200 categories in FOOD &amp; DRINK, SHOPPING &amp; SERVICES, ARTS &amp; ENTERTAINMENT, SPORTS &amp; RECREATION, PEOPLE &amp; PLACES and CANNABIS.  For 2019, we've expanded the voting to include more offbeat and alternative categories.
              </p>
            </div>

            <div class="col-sm-4 about-column">
              <img class="about-header-image" src="/static/images/icon3.png" alt="Best of issue">
              <p>
                On September 26, we'll announce the winners in our annual Best of Sac issue. Want to see who's won over the years?
                <router-link
                  tag="a"
                  class="margin-a-left"
                  :to="{name: 'home'}"
                  v-scroll-to="'#gallery'">
                  Check out past Best of issues!
                </router-link>
              </p>
            </div>

          </div>

          <div class="row" v-if="$store.getters.canVote && project.voting_link">
            <div class="col-xs-12 about-column uppercase voting-ends">
              <a :href="project.voting_link" target="_blank">The voting period ends {{ votingEnds }}.  Vote Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import VoteNow from '@/components/VoteNow.vue'

export default {
  props: {
    project: {
      type: Object,
      default: null
    }
  },
  components: {
    appVoteNow: VoteNow
  },
  computed: {
    aboutText () {
      return this.project.about.replace(/<h2><span>(.*?)<\/h2>/mg, '<h2><span>$1</span></span></h2>')
    },
    votingEnds () {
      const end = new Date(this.$store.getters.votingEnds)
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ]
      const monthName = months[end.getUTCMonth()]
      return `${monthName} ${end.getUTCDate()}, ${end.getFullYear()}`
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/_site_variables.scss';
  @import '@/assets/scss/partials/_mixins.scss';

  .about-header-image {
    margin: 0 auto 20px;
    display: block;
    width: 50%;
  }

  .about-column {
    img {
      max-width: 300px;
    }

    p:last-child {
      margin-bottom: 40px;
    }
  }

  .voting-ends {
    a {
      font-size: 110%;
      font-family: $default-font-primary;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/About.vue